import { useNavigate } from '@tanstack/react-router';

import { translate } from '../../helpers/translate.helper';
import { useRole } from '../../hooks/useRole';
import { IconSettings } from '../../icons/cdl/Settings';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

export const OpenSettings = () => {
    const navigate = useNavigate();
    const role = useRole();
    const { setOpen } = useShortcutMenu();

    if (!role.hasAnyAdminRights()) {
        return null;
    }

    return (
        <CommandItem
            onSelect={() => {
                navigate({
                    to: '/settings',
                });

                setOpen(false);
            }}
            Icon={IconSettings}
        >
            {translate('shortcutMenu.openSettings')}
        </CommandItem>
    );
};
